import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { afficherFichier } from '../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';

const CardSyndic = ({ Nom, Img, Descriptif }) => (
    <Card Titre={CardSyndic.titleName} SousTitre={Nom}>
        <div className="card-text mb-0">
            <p>
                {Img && (
                    <img
                        src={afficherFichier(Img)}
                        alt=""
                        className="rounded mx-auto d-block border border-secondary img-fluid img-logo"
                    />
                )}
            </p>
            <blockquote className="blockquote mb-0">
                <div dangerouslySetInnerHTML={{ __html: Descriptif.replace('<div>&nbsp;</div>', '') }} />
            </blockquote>
        </div>
        <Link to={{ pathname: '/MaMessagerie/Ecrire', state: { Incident: true } }} className="btn btn-outline-danger mt-3 mr-3">
            <i className="fa fa-exclamation-triangle" aria-hidden="true" /> Signaler un problème
        </Link>
        <Link to={'/MaMessagerie/Ecrire'} className="btn btn-outline-primary mt-3">
            Contacter mon syndic
        </Link>
    </Card>
);
CardSyndic.displayName = 'CardSyndic';
CardSyndic.titleName = 'Mon syndic';
CardSyndic.requiredProps = [
    'Nom', // Nom du syndic
    'Img', // Logo du syndic
    'Descriptif', // Description du syndic
];

function mapStateToProps({
    SynStore: {
        Syn: {
            Ind: { Nom },
            Img, Descriptif,
        },
    },
}) {
    return { Nom, Img, Descriptif };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardSyndic));



// WEBPACK FOOTER //
// ./src/components/MonSyndic/CardSyndic.js